import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './taskboard.action';

@Injectable({ providedIn: 'root' })
export class TaskboardTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    dossierId: number = 0; //Do not alter being used in dossier task tabs
    memberId: number = 0;
    progressCount: number = 0;

    pagination = [];
    filters = {
                created_at: '',
                last_message_at: '',
                created_by_name: '',
                task_type: null,
                task_statuses_name: null,
                member_name: ''
            };

    unReadTasks: string[];
    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'created_at';
    initialSortDirection = 'desc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    hasFilter = false;
    section = '';
    clubs = [];
    categories = [];
    statuses = [];
    types = [
        { id: "1", name: "COMMUNICATION.general"},
        { id: "2", name: "COMMUNICATION.specific"}
    ];
    columns = [
                { prop: 'created_at', name: 'COMMON.created-date', sortable: true, hasFilter: true, filter: "date", widthSet: 155},
                { prop: 'last_message_at', name: 'COMMUNICATION.last-message-at', sortable: true, hasFilter: true, filter: "date", widthSet: 155},
                { prop: 'member_name', name: 'COMMUNICATION.member-name', sortable: true, hasFilter: true, filter: "input", widthSet: 180},
                { prop: 'created_by_name', name: 'COMMUNICATION.created-by', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'task_type', name: 'COMMUNICATION.communication-type', sortable: true, hasFilter: true, filter: "select", options: 'types', options_id: "id", options_label: "name", widthSet: 350 },
                { prop: 'task_statuses_name', name: 'COMMON.status', sortable: true, hasFilter: true, filter: "select", options: 'statuses', options_id: "id", options_label: "name" },
                // { prop: 'actions', name: 'COMMON.actions', sortable: false, hasFilter: false, filter: ""},
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords());
    }

    hasActiveFilters(){

        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }
    
    resetState(){
        this.filters = {
            created_at: '',
            last_message_at: '',
            created_by_name: '',
            task_type: null,
            task_statuses_name: null,
            member_name: ''
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;
    }

    resetFilters(){
        this.resetState();
        this.loadRecords();
    }

}